export const history = require("history").createBrowserHistory()
//export const history = createBrowserHistory();